import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowPathUp"><Path d="M12.2501 21.2498H11.7501C10.0932 21.2498 8.75005 19.9067 8.75005 18.2498V10.2498H5.32127C4.89673 10.2498 4.66536 9.75411 4.93801 9.42869L10.8503 2.37212C11.4498 1.65656 12.5503 1.65656 13.1498 2.37212L19.0621 9.42869C19.3347 9.75411 19.1034 10.2498 18.6788 10.2498H15.2501V18.2498C15.2501 19.9067 13.9069 21.2498 12.2501 21.2498Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowPathUp;
